// Define the type for the conditionsType object
interface ConditionsDateType {
  [key: string]: number;
}

// Define the conditionsDateType object with appropriate type annotations ((in days))
const conditionsDateType: ConditionsDateType = {
  WhatsAppChannel: 1,
  InstagramChannel: 7,
  FacebookChannel: 7,
  TikTokChannel: 2,
};

export default conditionsDateType;
